(ns common.schema.entities.graph-entity
  (:require [common.schema.schema-utils :as su]
            [clojure.set :as set]))

(def graph-entity-mapping
  {:entity.type/graph-company :entity.type/company
   :entity.type/graph-fund :entity.type/fund
   :entity.type/graph-fof-asset :entity.type/fof-asset
   :entity.type/graph-person :entity.type/person})

(def entity-graph-mapping
  (set/map-invert graph-entity-mapping))

(def business-id
  (su/text-simple-field
   :graph-entity/business-id "Business ID"
   {:default-field-visibility :in-use
    :authorization {:access/read :role/user
                    :access/write :role/user}}))

(def tin
  (su/text-simple-field
   :graph-entity/tin
   "TIN"
   {:default-field-visibility :not-in-use
    :authorization {:access/read :role/user
                    :access/write :role/user}}))

(def giin
  (su/text-simple-field
   :graph-entity/giin
   "GIIN"
   {:default-field-visibility :not-in-use
    :authorization {:access/read :role/user
                    :access/write :role/user}}))

(def duns-number
  (su/text-simple-field
   :graph-entity/duns-number
   "DUNS number"
   {:default-field-visibility :not-in-use
    :authorization {:access/read :role/user
                    :access/write :role/user}}))

;; same attribute for each graph-company/-fund/-fof-asset
;; => same set of options/named-values:
;;    -if different wanted, use entity-type specific e.g. :graph-fund/legal-form
(def jurisdiction
  (su/option-field
   :graph-entity/jurisdiction "Jurisdiction"
   {:default-field-visibility :not-in-use
    :authorization {:access/read :role/user
                    :access/write :role/user}}))

(def domicile
  (su/option-field
   :graph-entity/domicile "Domicile"
   {:default-field-visibility :not-in-use
    :authorization {:access/read :role/user
                    :access/write :role/user}}))

(def legal-form
  (su/option-field
   :graph-entity/legal-form "Legal form"
   {:default-field-visibility :not-in-use
    :authorization {:access/read :role/user
                    :access/write :role/user}}))

(def schema
  (concat
   (su/single-ref-field
    :graph-entity/entity
    "Target entity"
    #{:entity.type/company
      :entity.type/person
      :entity.type/fund
      :entity.type/fof-asset}
    {:default-field-visibility :in-use-disabled
     :authorization {:access/read :role/user
                     :access/write :role/system}
     :system-required? true
     :system-semantics su/user-provided-system-required-field-semantics
     :mandatory-config :mandatory/always})

   (su/text-simple-field
    :graph-entity/label
    "Map name"
    {:default-field-visibility :in-use-disabled
     :authorization {:access/read :role/user
                     :access/write :role/user}
     :system-required? true
     :system-semantics su/user-provided-system-required-field-semantics
     :mandatory-config :mandatory/always
     :constraints {:constraint/string-min-length 1}})

   (su/keyword-field
    :graph-entity/entity-type
    "Target entity-type"
    [{:key :entity.type/company
      :label "Company"}
     {:key :entity.type/person
      :label "Person"}
     {:key :entity.type/fund
      :label "Fund"}
     {:key :entity.type/fof-asset
      :label "FoF-asset"}]
    {:default-field-visibility :in-use-disabled
     :editor-type :editor.type/none
     :authorization {:access/read :role/user
                     ;; set at creation - must match entity-type of :graph-entity/entity
                     :access/write :role/system}
     :system-required? true
     :system-semantics su/user-provided-system-required-field-semantics
     :mandatory-config :mandatory/always})))
